import React from 'react'
import axios from 'axios';
import { useSelector } from "react-redux";
import ReactLoading from "react-loading";
import CustomerQuestions from './Questions/CustomerQuestions';
import QuestionBody from './Questions/QuestionBody';


const ReviewBody = () => {	
  const reviewQuestions = useSelector((state) => state.EMenu.reviewQuestions);
  const auth_token = useSelector((state) => state.Company.auth_token);
  //component local variables
  const [questionIndex, setQuestionIndex] = React.useState(-1);
  //display questions
  const currentQuestion = reviewQuestions[questionIndex % reviewQuestions.length];
  
  //use ref
  const formRef = React.useRef(null)

  return (
    <div className="relative w-[90%] md:pb-2 m-auto bg-white rounded-b-lg">
        <div className="flex w-full justify-center text-center items-center h-[10vh]">
            <h1 className="text-md font-black">
                Let's get some feedback from you!
            </h1>
        </div>
      <hr className="w-full"/>
      <form  ref={formRef} className="h-[60vh]">
        {reviewQuestions.length > 0 ? (
          <div className='h-full'>
            {questionIndex < 0 ? (
              <CustomerQuestions
              setIndex={setQuestionIndex}
              />
            ):
            (
            <div className='h-full'>
              {currentQuestion && 
                (
                <div id={currentQuestion.id} className='h-[70%]'>
                  <QuestionBody
                    Question= {currentQuestion.Question}
                    QuestionType= {currentQuestion.QuestionType}
                    Required= {currentQuestion.Required}
                    Option= {currentQuestion.Option}
                    index={questionIndex}
                    setIndex={setQuestionIndex}
                    length = {reviewQuestions.length}
                  />
                </div>
                )
              }
            </div>)
            }
          </div>)
          : (
            <div className="flex justify-center items-center p-20">
              <ReactLoading
                type={"spin"}
                color={"#ccc"}
                height={"20%"}
                width={"20%"}
              />
            </div>
          )}
      </form>
    </div>
  )
}

export default ReviewBody